import React, { Component } from "react";
import imageCompression from "browser-image-compression";

class CustomFileInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // error: this.props.error,
      selectedImage: this.props.defaultFile,
    };
  }

handleImageChange = async (e) => {
  const file = e.target.files[0];

  if (file) {

    // ✅ Original image size
    console.log("Original Size (bytes):", file.size);
    console.log("Original Size (KB):", (file.size / 1024).toFixed(2));
    console.log("Original Size (MB):", (file.size / (1024 * 1024)).toFixed(2));

    // Compress the image
    const options = {
      maxSizeMB: 1,          // target size <1MB
      maxWidthOrHeight: 1024,
      useWebWorker: true
    };

    try {
      const compressedFile = await imageCompression(file, options);

      // ✅ Compressed image size
      console.log("Compressed Size (bytes):", compressedFile.size);
      console.log("Compressed Size (KB):", (compressedFile.size / 1024).toFixed(2));
      console.log("Compressed Size (MB):", (compressedFile.size / (1024 * 1024)).toFixed(2));

      // Convert compressed file to Base64
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64Data = event.target.result;

        this.setState({
          selectedImage: base64Data
        });

        // Callbacks to parent component / form
        this.props.onBase64Change(base64Data);
        this.props.setFieldValue(this.props.val, base64Data);
        this.props.onDataChange(compressedFile); // compressed file
      };

      reader.readAsDataURL(compressedFile);

    } catch (error) {
      console.log("Error while compressing:", error);
    }
  }
};

  render() {


    const { selectedImage } = this.state;
    const { error } = this.props;
    // console.log("Error", error);
    // console.log("Error 12122", this.state.error);
    const borderStyle = error ? { border: "2px solid red" } : {};
    return (
      <div
        // style={{ ...styles.imageBox, ...borderStyle }}
        style={styles.imageBox}
        onClick={() => this.fileInput.click()}
      >
        {selectedImage ? (
          <img src={selectedImage} alt="Selected" style={styles.image} />
        ) : (
          <div style={styles.border}>
            <i className="ri-image-add-line" style={styles.icon}></i>
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          ref={(fileInput) => (this.fileInput = fileInput)}
          onChange={this.handleImageChange}
        />
      </div>
    );
  }
}
const styles = {
  imageBox: {
    width: "100%", // Changed width to 100%
    height: "280px", // Changed height to auto for responsiveness
    border: "1px solid #000",
    borderRadius: "0px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",

  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  border: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    // border: "2px dashed #ccc",
  },
  icon: {
    fontSize: "50px",
    color: "#ccc",
  },
};

export default CustomFileInput;
